import type { ReactNode } from 'react';
import { DiscoveryRightRail } from '@/platform/calendar/CalendarSidebarWidget';
import { GrowthPathTourCoach } from '@/platform/hostgrowth/GrowthPathTourCoach';
import { GrowthPathTourProvider } from '@/platform/hostgrowth/GrowthPathTourContext';
import { NavTourCoach } from '@/platform/navTour/NavTourCoach';
import { NavTourControlProvider } from '@/platform/navTour/NavTourControlContext';
import { isOpsItsmBuild } from '@/platform/servicedesk/isOpsItsmBuild';
import { CommunioSidebar } from './CommunioSidebar';

type Props = {
  children: ReactNode;
  right?: ReactNode;
  hideSidebar?: boolean;
};

/** Three-column discovery shell for Communio Social product tenants (not paydirt, not ops ITSM). */
export function CommunioDiscoveryLayout({ children, right, hideSidebar }: Props) {
  if (isOpsItsmBuild()) {
    return <>{children}</>;
  }
  return (
    <NavTourControlProvider>
      <GrowthPathTourProvider>
        <div className="discovery-layout" data-testid="communio-discovery-layout">
          <div className="discovery-layout__grid">
            {!hideSidebar && (
              <div className="discovery-layout__left">
                <CommunioSidebar />
              </div>
            )}
            <main className="discovery-layout__main">{children}</main>
            {(right || !hideSidebar) && <DiscoveryRightRail right={right} />}
          </div>
          <NavTourCoach />
          <GrowthPathTourCoach />
        </div>
      </GrowthPathTourProvider>
    </NavTourControlProvider>
  );
}
